export const VALIDATIONS = {
  ENGLISH_LETTERS_AND_NUMBERS: /^[a-zA-Z][a-zA-Z0-9]*$/,
  NUMBERS_ONLY: /^[0-9]*$/,
  GLOBAL_NUMBERS_ONLY: /[^0-9]/g,
  ENGLISH_ONLY: /^[a-zA-Z\s]*$/,
  ARABIC_ONLY: /^[\u0600-\u06ff\s]*$/,
  SAUDI_MOBILE: /^(?:\+966|966)5[0-9]{8}$/, // Saudi mobile - international format only (+966/966)
  SAUDI_LANDLINE: /^(?:\+966|966)(?:1[1-7])[0-9]{7}$/, // Saudi landline - international format only (+966/966)
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};
